export const profileData = {
    name: 'Reza Aldiansyah, ST, MTI, PMP, PMI-PMOCP',
    phone: '+62811935083',
    position: 'Digital Transformation Leader | Passionate About Purposeful Tech | CDO-in-the-Making | PMP & PMO-CP | Human-Centered SystemsThinker',
    bio: 'Strategic and people-centered digital transformation leader with 15+ years of multidisciplinary experience across IT, education, nonprofit, and telecom sectors. Adept at aligning business goals with innovative technology solutions to drive efficiency, transparency, and sustainable growth. Recognized for successfully leading cross-functional teams, executing high-stakes projects, and shaping long-term digital strategies.',
    photo_url: 'https://res.cloudinary.com/dief37xrg/image/upload/v1765280185/Reza_Photo_2025_ksweu3.png',
    linkedin_url: 'https://linkedin.com/in/rezaaldiansyah',
    email_url: 'mailto:reza.aldi@gmail.com',
    about: 'Strategic and people-centered digital transformation leader with 15+ years of multidisciplinary experience across IT, education, nonprofit, and telecom sectors. Adept at aligning business goals with innovative technology solutions to drive efficiency, transparency, and sustainable growth. Recognized for successfully leading cross-functional teams, executing high-stakes projects, and shaping long-term digital strategies. Certified PMP and PMO-CP professional with deep commitment to continuous improvement and impact-driven leadership.',
    achievements: [
        {
            title: 'Project Manager – SymEX 2024, PMI Indonesia Chapter',
            desc: 'Directed the 12th International Symposium and Exhibition on Project Management in Malang, attended by 225+ participants and 16 international speakers. Delivered full event lifecycle management from planning to execution.'
        },
        {
            title: 'Head of SISDATA – Al Fatih Pilar Peradaban Foundation',
            desc: 'Led end-to-end digital transformation across 34 branches. Designed and deployed a centralized system integrating data of students, staff, and parents, significantly improving operational efficiency.'
        },
        {
            title: 'Coordinator of Media & IT – DIKTI, Al Fatih Pilar Peradaban Foundation',
            desc: 'Standardized social media and digital asset operations across four academies. Built systems and teams to enhance digital engagement and content consistency.'
        },
        {
            title: 'Transformation Lead – Asy-Syuraa Batam Foundation',
            desc: 'Implementing business and digital process changes that generate recurring profits, enabling the provision of additional annual Islamic holiday allowances, periodic provision of basic necessities, and bonuses for 50+ employees.'
        },
        {
            title: 'Gold Award – Engineering Award for Excellence (2008)',
            desc: 'Recognized for successful IPTV pilot project implementation in 6 cities with PCCW and PT Telkom.'
        },
        {
            title: 'Cascade’s Achievers Award (2007)',
            desc: 'Honored for exceptional performance and CS Core Network Operations leadership at PCCW.'
        }
    ],
    experience: [
        {
            role: 'CEO & Founder',
            company: 'PT Shifr Asia Inovasi',
            period: 'Feb 2026 - Present',
            desc: 'Founded and actively lead a consultancy focused on IT project management, digital strategy, and enterprise systems. I partner directly with stakeholders to guide tech projects from concept to launch, ensuring they align with global PMP standards. Beyond delivering technology, I help businesses streamline their operations, overcome market challenges, and unlock new revenue streams.'
        },
        {
            role: 'Chief Business Development Officer',
            company: 'Pinara Digital',
            period: 'Jan 2022 - Present',
            desc: 'Defined company vision and go-to-market strategy for IT and digital marketing consulting. Built strategic partnerships and led acquisition efforts.'
        },
        {
            role: 'IT Project Management Consultant',
            company: 'Independent',
            period: 'Jun 2015 - Present',
            desc: 'Advised SMEs and education institutions on IT transformation and digital revenue strategies. Managed nationwide application and data integration project for 33-branch education network.'
        },
        {
            role: 'Lecturer',
            company: 'University of Indonesia',
            period: 'Jan 2020 - Dec 2021',
            desc: 'Taught courses in Information Technology, E-Commerce, and Fintech. Mentored student teams for global competitions including the Chatbot Challenge.'
        },
        {
            role: 'Chief Technology Officer',
            company: 'CariMobil',
            period: 'Feb 2021 - Sep 2021',
            desc: 'Formulated product technology roadmap and launch strategies. Coordinated with stakeholders and ensured milestone delivery.'
        },
        {
            role: 'Junior Manager – IT Planning & PM Unit',
            company: 'BNI Syariah',
            period: 'Sep 2015 - Mar 2016',
            desc: 'Produced board-level IT progress and KPI reports. Managed projects worth IDR 5 billion and served as acting head of PM Unit.'
        }
    ],
    education: [
        {
            degree: 'Magister of Information Technology',
            school: 'Universitas Indonesia',
            year: '2008 - 2010'
        },
        {
            degree: 'Bachelor of Telecommunication Engineering',
            school: 'Sekolah Tinggi Teknologi Telkom',
            year: '2001 - 2006'
        }
    ],
    skills: ['Digital Transformation Strategy', 'Enterprise System Integration', 'IT Governance', 'Project Management (PMP)', 'PMO-CP', 'Agile & Waterfall', 'Business Process Optimization', 'Team Leadership', 'Cross-functional Collaboration', 'Change and Stakeholder Management', 'SEO & Digital Asset Management', 'Content Strategy & Management'],
    languages: [
        'Bahasa Indonesia: Native',
        'English: Full Professional Proficiency',
        'Arabic: Elementary Proficiency'
    ]
};
